<section fxLayout="column" fxLayoutGap="16px">
  <div class="title-skeleton-wrapper" *ngIf="canShowSkeletonView() || hasCreelPositions()">
    <span class="title">{{ 'TEXTILE_DATA.MATERIAL_SET.ARRANGE_CREEL_POSITIONS' | bmsTranslate }}</span>
  </div>
  <div class="list-skeleton-wrapper">
    <article
      fxLayout="column-reverse"
      fxLayoutAlign="space-around"
      fxLayoutGap="16px"
      class="creel-positions"
      *ngIf="!canShowSkeletonView()"
      cdkDropList
      cdkDropListOrientation="vertical"
      (cdkDropListDropped)="onDropCreelPosition($event)"
    >
      <app-creel-position
        *ngFor="let creelPosition of materialSet.creelPositions; let creelPositionIndex = index"
        [creelPosition]="creelPosition"
        [creelPositionIndex]="creelPositionIndex"
        [materialSet]="materialSet"
        [canShowError]="canShowErrorForCreelPosition(getActualCreelPositionIndex(creelPosition))"
        [canEditMaterialSet]="canEditMaterialSet"
        (selectedCreelPositionChanged)="selectedCreelPositionChanged.emit()"
        (deselectAllSelectedCreelPositions)="deselectAllSelectedCreelPositions()"
        (creelPositionHasBeenChanged)="creelPositionHasBeenChanged.emit()"
        cdkDrag
        cdkDragBoundary=".creel-positions"
        cdkDragLockAxis="y"
        [cdkDragDisabled]="!canEditMaterialSet"
      ></app-creel-position>
    </article>
  </div>
</section>
